import { render, staticRenderFns } from "./extra-gruppencode.vue?vue&type=template&id=87f19360&scoped=true&lang=pug&"
import script from "./extra-gruppencode.vue?vue&type=script&lang=js&"
export * from "./extra-gruppencode.vue?vue&type=script&lang=js&"
import style0 from "./extra-gruppencode.vue?vue&type=style&index=0&id=87f19360&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f19360",
  null
  
)

export default component.exports